//—— Meta Pixel ——
//
//  只負責「載入 Pixel」與「送一個事件」。要在哪裡送、送什麼，由呼叫端決定
//  （路由層面的在 App.js 的 PixelTracker，結帳在 service/payment-service）。
//
//  —— 沒設定就完全安靜 ——
//  REACT_APP_META_PIXEL_ID 沒給時，這支不載入任何東西、不發任何請求，
//  track() 直接 return。本機開發與尚未設定的環境不會噴錯，也不會
//  把測試流量算進正式的 Pixel 裡（那會汙染學習資料）。
//
//  ⚠️ REACT_APP_* 是**建置時烙進 bundle 的**，不是執行時讀的（CLAUDE.md）。
//  Cloud Run 上改環境變數不會讓已經打包好的前端拿到新值 —— 要重新 build。
//  驗法：抓線上的 main.*.js，grep 那串 Pixel ID 在不在。
//
//  —— 為什麼不直接寫在 public/index.html ——
//  寫在那裡的話，每一次事件都要用全域的 fbq，而且沒設定時仍然會去
//  connect.facebook.net 抓一支 js。包成模組才擋得住「沒設定就不要動」。
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

//Pixel 的標準事件。自訂事件用字串直接傳
//  （Meta 對自訂事件名沒有限制，但要跟後端 CAPI 送的那個**一字不差**）。
export const EVENTS = {
  PAGE_VIEW: "PageView",
  VIEW_CONTENT: "ViewContent",
  INITIATE_CHECKOUT: "InitiateCheckout",
  PURCHASE: "Purchase",

  //  —— 自訂事件：抵達報價點 ——
  //  三條漏斗長度不一樣（報告要走完十二題問診、問卦只要打一句話），
  //  各自用不同事件優化的話，廣告組之間無法放在同一把尺上比較。
  //  所以在「等價深度」各打一次同一個事件：
  //      報告類  抵達故事頁（答完問診、看到自己的命盤）
  //      票券類  切到購券分頁（問題打完、知道要付錢了）
  //  這是廣告組能用 CBO 公平分配預算的前提。
  REACHED_OFFER: "ReachedOffer",
};

let ready = false;

//載入 Pixel 的那段官方 snippet，改寫成不污染全域命名空間的形式。
//  只跑一次 —— SPA 不會重新整理，重複載入會讓同一個事件被算兩次。
const load = () => {
  if (ready || !PIXEL_ID || typeof window === "undefined") return;
  ready = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
};

//有沒有在運作。呼叫端不需要知道細節，但偵錯時看得到
export const isPixelOn = () => Boolean(PIXEL_ID);

//送一個事件。
//  name 是標準事件就用 track，自訂事件要用 trackCustom ——
//  用錯的話 Meta 會收下但歸類到「未定義」，在事件管理工具裡看不到。
export const track = (name, params) => {
  if (!PIXEL_ID) return;
  load();
  if (!window.fbq) return;
  const standard = Object.values(EVENTS).includes(name) && name !== EVENTS.REACHED_OFFER;
  window.fbq(standard ? "track" : "trackCustom", name, params || {});
};

//—— 給後端 Conversions API 對人用的兩個 cookie ——
//
//  _fbp 是 Pixel 自己種的瀏覽器識別，_fbc 是從廣告點進來時由網址上的
//  fbclid 轉存的。把它們跟著訂單存下來，付款成功時由後端一起送 ——
//  比對品質（match quality）差很多。
//
//  只有 email 的話 Meta 只能靠雜湊比對，而買命理報告的人常用小號信箱；
//  帶著 _fbc 等於直接告訴 Meta「就是你那一次點擊帶來的」。
export const getFbCookies = () => {
  if (typeof document === "undefined") return { fbp: "", fbc: "" };
  const read = (k) => {
    const m = document.cookie.match(new RegExp("(^|; )" + k + "=([^;]*)"));
    return m ? decodeURIComponent(m[2]) : "";
  };
  return { fbp: read("_fbp"), fbc: read("_fbc") };
};

export default { track, EVENTS, isPixelOn, getFbCookies };
